<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="70vw"
  (onClose)="cancel()"
  *transloco="let t; read: 'widget-group-datasource-selector-component'"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div class="xi-modal__container widget-group-datasource-selector__container">
          <div class="widget-group-datasource-selector__content-container">
            <div class="kxi-text-center">
              <h2 class="xi-modal__title">{{ t('select-source') }}</h2>

              <p class="kxi-text-medium">
                {{ t('sub-heading') }}
              </p>
            </div>

            <div class="widget-group-datasource-selector__content">
              <app-datasource-selector
                [dataSources]="dataSources"
                [previousDataSourceId]="previousDataSourceId"
                (dataSourceSelect)="selectedDataSource = $event"
              ></app-datasource-selector>
            </div>

            <div class="widget-group-datasource-selector__action xi-modal__actions">
              <xi-default-button
                buttonSize="large"
                text="{{ t('cancel') }}"
                fill="text"
                (onClick)="cancel()"
              ></xi-default-button>

              <xi-default-button
                text="{{ t('next') }}"
                buttonSize="large"
                [disabled]="!selectedDataSource"
                (onClick)="confirm()"
              ></xi-default-button>
            </div>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
